import I18n from 'I18n';
import ResponsiveRenderer from 'developer-docs-shared-components/components/ResponsiveRenderer';
import UIIcon from 'UIComponents/icon/UIIcon';
import { EERIE } from 'HubStyleTokens/colors';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Icon shown next to a search result, indicating its page type.
 */
export const ResultIcon = ({
  primaryCategory
}) => {
  const renderDesktop = useCallback(() => {
    const isReference = primaryCategory === 'reference';
    return /*#__PURE__*/_jsx(UIIcon, {
      "data-test-id": "result-icon",
      name: isReference ? 'code' : 'bulb',
      size: 30,
      color: EERIE,
      screenReaderText: isReference ? I18n.text('developer-docs-ui.navigation.reference.primaryNavLinkLabel') : I18n.text('developer-docs-ui.navigation.guides.primaryNavLinkLabel')
    });
  }, [primaryCategory]);
  const renderMobile = useCallback(() => null, []);
  return /*#__PURE__*/_jsx(ResponsiveRenderer, {
    renderDesktop: renderDesktop,
    renderMobile: renderMobile
  });
};